import { useIntl } from 'react-intl';
import {
  IconCustomAurora,
  IconEye,
  IconFileDescription,
  IconMessage,
  IconPhoto,
  IconSchema,
} from '@rossum/ui/icons/tabler';
import { Box, Stack, SvgIcon, Typography } from '@rossum/ui/material';

export const ChatWelcomeScreen = () => {
  const intl = useIntl();
  const tips = [
    {
      icon: IconEye,
      text: intl.formatMessage({ id: 'features.chat.welcome.tip.subset' }),
    },
    {
      icon: IconPhoto,
      text: intl.formatMessage({ id: 'features.chat.welcome.tip.attachments' }),
    },
    {
      icon: IconSchema,
      text: intl.formatMessage({ id: 'features.chat.welcome.tip.diagrams' }),
    },
    {
      icon: IconFileDescription,
      text: intl.formatMessage({ id: 'features.chat.welcome.tip.markdown' }),
    },
    {
      icon: IconMessage,
      text: intl.formatMessage({
        id: 'features.chat.welcome.tip.slashCommands',
      }),
    },
  ];
  return (
    <Stack sx={{ flex: 1, minHeight: 0 }}>
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 4,
        }}
      >
        <Stack alignItems="center" spacing={3} sx={{ maxWidth: 420 }}>
          <SvgIcon fontSize="xLarge" sx={{ color: 'aurora.main' }}>
            <IconCustomAurora />
          </SvgIcon>

          <Typography
            variant="h5"
            fontWeight={600}
            textAlign="center"
            data-cy="chat-welcome-heading"
          >
            {intl.formatMessage({ id: 'features.chat.welcome.title' })}
          </Typography>

          <Stack
            component="ul"
            spacing={1.5}
            sx={{ m: 0, p: 0, listStyle: 'none' }}
          >
            {tips.map(tip => (
              <Stack
                key={tip.text}
                component="li"
                direction="row"
                spacing={1.5}
                alignItems="center"
              >
                <SvgIcon fontSize="small" sx={{ color: 'aurora.main' }}>
                  <tip.icon />
                </SvgIcon>
                <Typography variant="body2" color="text.secondary">
                  {tip.text}
                </Typography>
              </Stack>
            ))}
          </Stack>
        </Stack>
      </Box>
    </Stack>
  );
};
